export default "__VITE_PUBLIC_ASSET__17e8f509__"